export const URL = {
  movieList: "https://api.themoviedb.org/3/movie/upcoming?language=en-US",
  movieDetails: "https://api.themoviedb.org/3/movie",
  movieDetail: "https://api.themoviedb.org/3/movie/movie_id?language=en-US",
  movieSearch: "https://api.themoviedb.org/3/search/movie",
  thumbnail_image: "https://image.tmdb.org/t/p/w220_and_h330_face",
  full_image: "https://image.tmdb.org/t/p/w500",
};
